// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__22GlK","validationTips":"StatementDescriptor_validationTips__30qma"};